import { JsonError } from '../errors/did-json-error';

export enum LibraryItemType {
    CLIP = 'clip',
    TALK = 'talk',
    PROJECT = 'project',
    TRANSLATION = 'translation',
    SIMPLESHOW = 'simpleshow',
}

export enum LibraryItemStatus { // merge of TalkStatus and ProjectStatus
    Created = 'created',
    Validating = 'validating',
    Done = 'done',
    Error = 'error',
    Started = 'started',
    Rejected = 'rejected',
    Ready = 'ready',
}

export interface LibraryItem {
    id: string;
    type: LibraryItemType;
    status: LibraryItemStatus;
    created_at: string;
    modified_at: string;
    started_at?: string;
    created_by?: string;
    video_url?: string;
    thumbnail_url: string;
    name: string;
    duration?: number;
    error?: JsonError;
    is_default?: boolean;
    background?: { color: string };
    metadata?: any & {
        videoPageUrl?: string;
        editPageUrl?: string;
        reviewPageUrl?: string;
    };
    subtitles?: boolean;
    subtitles_url?: string;
    presenter_version?: string;
    presenter_labels?: string[];
    presenter_versions?: string[];
    target_languages?: string[];
    is_editable?: boolean;
}

export const itemIsProject = (item: LibraryItem) => item.type === LibraryItemType.PROJECT;
export const itemIsClip = (item: LibraryItem) => item.type === LibraryItemType.CLIP;
